<template>
  <div>
    <div class="main-header">
      {{ placeHolder ? placeHolder : "" }}
    </div>
    <div class="main-graph-window">
      <div class="chart-section">
        <div class="deposit-chart" id="main-chart-questions-3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import moment from "moment";

const UsersBar = {
  type: "bar",
  options: {
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 15,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        offset: -5,

        font: {
          family: "Montserrat"
        },
        fontSize: 9,
        color: function(context) {
          return context.dataset.borderColor;
        },
        formatter: function(value) {
          return value === 0 ? "" : value;
        }
      }
    },

    maintainAspectRatio: false,
    gradientColors: [
      "rgba(29,140,248,0.2)",
      "rgba(29,140,248,0.0)",
      "rgba(29,140,248,0)"
    ],
    gradientStops: [1, 0.4, 0],
    responsive: true,
    scales: {
      yAxes: [
        {
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
          },
          ticks: {
            beginAtZero: true,
            //display:false,
            padding: 15,
            fontColor: "transparent", //"#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 1
          }
        }
      ],
      xAxes: [
        {
          id: "bar-x-axis1",
          // barPercentage: 1.0,
          // categoryPercentage: 0.5,
          gridLines: {
            drawBorder: false,
            color: "transparent",
            zeroLineColor: "transparent"
          },
          ticks: {
            padding: 0,
            fontColor: "#44A2D2",
            fontFamily: "Montserrat",
            fontSize: 10
          }
        }
      ]
    },
    legend: {
      display: false
    },
    // legend: {
    //     position: "top",
    //     align: "end",
    //     labels: {
    //         boxWidth: 20,
    //         fontSize: 10,
    //         display: false
    //     },
    //     onHover: function(e) {
    //         e.target.style.cursor = 'pointer';
    //     }
    // },
    hover: {
      onHover: function(e) {
        const point = this.getElementAtEvent(e);
        if (point.length) e.target.style.cursor = "pointer";
        else e.target.style.cursor = "default";
      }
    }
  }
};

export default {
  name: "QuestionsCharts.component",
  computed: {
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "multiSelectChartData",
      "selectedCalendarType"
    ]),
    ...mapGetters("clients", ["getMultiSelectChartData"])
  },
  mixins: [UsersPermissionCheck],
  props: {
    mainData: {
      required: true,
      type: Object
    },
    mainSector: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      UsersBar: UsersBar,
      requestsForTabs: {},
      statusChartTab: null,
      allData: {},
      selectedTab: "",

      tabPaginate: 0,
      tabsLength: 8,
      ext_tabs: [],
      graphTabs: [],
      globalDateRange: "TODAY",
      mainCalendarSection: "REG",
      hoveringTab: false,
      chartData: [],
      placeHolder: null
    };
  },
  created() {},
  watch: {
    multiSelectChartData: {
      handler() {
        this.initialChartData(this.getMultiSelectChartData);
      },
      deep: true
    }
  },

  methods: {
    async initialChartData(data) {
      if (this.mainSector === data.selectedSector) {
        let element = document.getElementsByClassName(
          "dropdown-item btn btn-block btn-light-gray active"
        );
        $(element).removeClass("loading");
        if (data.fromChart) {
          return;
        }
        let tab = this.ext_tabs.filter(tab => {
          return tab.alias === this.selectedTab;
        });
        if (tab.length > 0) {
          await this.fetchExternalGraphs(tab[0]);
          return;
        }
        // this.$store.commit("clients/setSelectedCalendarType", {
        //   alias: this.mainCalendarSection,
        //   preset: null
        // });
        this.mainSector = data.selectedSector;
        this.allData = data;
        if (
          !data.hasOwnProperty("questionsData") ||
          !data.questionsData.hasOwnProperty(2)
        ) {
          return;
        }
        this.chartData = data.questionsData[3].data;
        this.placeHolder = data.questionsData[3].qLabel;
        let lineChartStatus = `main-chart-questions-3`;
        if (this.statusChartTab) {
          this.statusChartTab.destroy();
        }
        if (!this.chartData.hasOwnProperty(this.mainSector)) {
          this.createChart(lineChartStatus, this.chartData);
        }
      }
    },
    async TabClick(tab) {
      if (
        (!tab.hasOwnProperty("ex") && !tab.ex) ||
        (tab.hasOwnProperty("ex") &&
          tab.hasOwnProperty("combine") &&
          tab.combine)
      ) {
        if (tab.hasOwnProperty("subMenu")) {
          this.selectedSubTab = tab.subMenu[0].alias;
        }
        if (this.selectedTab !== tab.alias) {
          // this.$store.commit("clients/setSelectedCalendarType", {
          //   alias: this.mainCalendarSection,
          //   preset: null
          // });
        }
        let element = document.getElementsByClassName(
          "dropdown-item btn btn-block btn-light-gray active"
        );
        $(element).addClass("loading");
        this.selectedTab = tab.alias;
        let data = Object.assign({}, this.allData);
        data.selectedTab = tab.alias;
        data.fromChart = true;
        this.$store.commit("clients/setMultiSelectChartData", [
          data,
          this.mainSector
        ]);
      }
      if (tab.hasOwnProperty("ex") && tab.ex) {
        this.selectedTab = tab.alias;
        if (tab.hasOwnProperty("subMenu")) {
          this.selectedSubTab = tab.subMenu[0].alias;
        }
        await this.fetchExternalGraphs(tab);
      }
    },
    clickSubTab(subTab) {
      this.selectedSubTab = subTab.alias;

      //functions of sub tabs
    },

    namesFormatter(name, numLet = 3) {
      let first_name = name.split(" ")[0].substring(0, numLet);
      let second_name = "";
      name.split(" ").length > 1
        ? (second_name = name
            .split(" ")[1]
            .substring(0, 1)
            .toUpperCase())
        : (second_name = "");
      let fullName = first_name + " " + second_name;
      return fullName;
    },
    clickOnMainTab(alias) {
      this.$store.commit("clients/setMainGraphTabData", alias);
    },

    async fetchExternalGraphs(subSector) {
      if (this.statusChartTab) {
        this.statusChartTab.destroy();
      }
      let tab = subSector.alias;
      let element = document.getElementsByClassName(
        "dropdown-item btn btn-block btn-light-gray active"
      );
      $(element).addClass("loading");
      this.depUsersStatsToday = [];
      this.requestsForTabs[tab] = true;
      if (!this.showReset) {
        this.resetMainFilters();
      } else {
        this.mainFilters = this.generalQueryObject;
      }

      //functions for ext tabs

      this.requestsForTabs[tab] = false;
      $(element).removeClass("loading");
    },

    createChart(canvas, chartData) {
      let tempData = [];
      chartData.map(item => {
        tempData.push({
          name: item.title,
          size: item.count[0] + 5,
          value: item.count[0]
        });
      });
      //let counter = naCountriesData.reduce((a, b) => a + b)
      let dataToChart = [{ children: tempData }];
      let chart = anychart.treeMap(dataToChart, "as-tree");
      $("#" + canvas).html("");
      chart.container(canvas);
      let customColorScale = anychart.scales.linearColor();
      customColorScale.colors(["#DB7093", "#cb164d"]);
      chart.maxDepth(2);
      chart.headers(false);
      chart.colorScale(customColorScale);
      chart.padding(0);
      chart.draw();

      let credits = document.getElementsByClassName("anychart-credits");
      $(credits).hide();
    },

    paginate(stats) {
      let pageSize = this.tabsLength;

      let inputArray = stats;

      let result = inputArray.reduce((resultArray, item, index) => {
        const pageIndex = Math.floor(index / pageSize);

        if (!resultArray[pageIndex]) {
          resultArray[pageIndex] = []; // start a new page
        }

        resultArray[pageIndex].push(item);

        return resultArray;
      }, []);

      return result;
    },
    resetMainFilters() {
      this.mainFilters = {
        deposit_at_from: moment(this.defaultPresets().start).format(
          "YYYY-MM-DD"
        ),
        deposit_at_to: moment(this.defaultPresets().end).format("YYYY-MM-DD"),
        special_req: true
      };
    }
  }
};
</script>

<style scoped>
li {
  text-transform: uppercase;
}
.main-graph-window {
  width: 100%;
  min-height: 240px;
  background-color: #fff;
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
}
.main-header {
  width: 100%;
  min-height: 20px;
  text-align: center;
  background-color: #db2b72;
  color: #fff;
  margin-top: 5px;
  font-family: "Montserrat", Montserrat, serif;
  font-size: 14px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dropdown-item {
  height: 20px;
  min-height: 8%;
  padding: 1px 0px;
  margin: 0px;
  border-radius: 0px;
  outline: none;
  font-size: 12px;
  display: flex;
  text-align: left;
  transition: all 0.3s ease-in-out;
  border-radius: 0px 5px 5px 0px;
  //margin-bottom: 1px;
  background-color: #efefef;
  border: 1px solid #e5e4e4;
  position: relative;
}
.dropdown-item:focus {
  outline: none;
}
.dropdown-item:hover {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}
.dropdown-item.cal-match {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}

.dropdown-toggle .toggle-left-side {
  /*margin-right: 10px;*/
  margin-right: 36px;
}

.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 95px;
  border-radius: 0px;
  padding: 0px;
}

.dropdown-item-left {
  margin-left: 10px;
  /*float: left;*/
  flex: 1;
  font-weight: 500;
}
.dropdown-item-right {
  flex: 1;
}
.chart-section {
  flex: 2;
  width: 92%;
  min-height: 100%;
  max-height: 200px;
  display: flex;
}
.deposit-chart {
  width: 100%;
  min-height: 100%;
}
.longTitleFontSize {
  font-size: 11px;
}
li.active {
  background-color: #00acff;
  color: #fff;
}
.sized_chart {
  max-width: 74%;
  position: relative;
}
.trans-dep-chart {
  position: relative;
  max-width: 13%;
  min-width: 13%;
  max-height: 100%;
  margin-left: 3px;
}
.dep-goal-chart {
  position: relative;
  max-width: 9%;
  min-width: 9%;
  max-height: 100%;
  margin-left: 3px;
}

.sub-menu-main {
  left: 55px;
  top: -1px;
  position: absolute;
  display: flex;
  max-height: 20px;
}
.sub-menu-main li {
  background-color: #efefef;
  color: #0a0a0a;
  cursor: pointer;
  transform: none !important;
  max-height: 20px;
  margin-left: 1px;
  border-radius: 5px;
}
.sub-menu-main li:hover {
  background-color: #dedede;
}
.sub-menu-main li.active {
  background-color: #c12fff;
  color: #fff;
}

.dropdown-item-left.sub {
  margin-left: unset;
  width: 50px;
  text-align: center;
}
li.loading {
  background: linear-gradient(-45deg, #db7093, #ac1746, #db7093, #ac1746);
  background-size: 500% 500%;
  animation: gradient 3s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 0%;
  }

  100% {
    background-position: 100% 50%;
  }
}

.arrow-down {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffa400;
  font-size: 29px;
  cursor: pointer;
}
.disabled_scroll {
  display: none;
}
</style>
